module.exports = __webpack_public_path__ + "static/media/logos_squares_Platinum_HKE.28306e48.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Platinum_HKE.png
// module id = 90
// module chunks = 0